// <=IE11
if (typeof Object.assign != 'function') {
    Object.assign = function (target, varArgs) {
        'use strict';
        if (target == null) { // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }
        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) { // Skip over if undefined or null
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}

// moderne Version für IntersectionObserver
var observerLozad = lozad('.mpLazy', {
    load: function load(element) {
        if (!window.HTMLPictureElement) {
            // src-Attribute nur nutzen, wenn Browser srcset nicht unterstützt!
            // Achtung: iOS 8 bis 8.4 schlagen hier auch rein, weil der Support erst richtig mit 9.2 gegeben ist
            if (element.getAttribute('data-src')) {
                element.src = element.getAttribute('data-src');
            }
        } else {
            if (element.getAttribute('data-srcset')) {
                element.srcset = element.getAttribute('data-srcset');
            }
        }

        // "normales" Hintergrundbild mit Referenz im Code
        if (element.getAttribute('data-background-image')) {
            element.style.backgroundImage = 'url(' + element.getAttribute('data-background-image') + ')';
        }

        // CSS-Klasse dazuschalten z.B. um ein CSS-definiertes Hintergrundbild zu laden
        if (element.getAttribute('data-add-css')) {
            element.className += ' ' + element.getAttribute('data-add-css');
        }
    }
});
observerLozad.observe();

// Select2
var observerLozadSelect2 = lozad('.mpSelect2,.mpSelect2Class,.mpSelect2BrandIds,.mpModelSearch,#mpBrandRelation,#mpInternalNumber', {
    load: function load(element) {
        if (typeof mp == 'object' && typeof mp.select2 == 'object') {
            mp.select2.lazyLoadSelect2()
        } else {
            mpSelect2OnReadyInits = true;
        }
    }
});
observerLozadSelect2.observe();

// AdServer
var observerLozadAds = lozad('#mpPartnerRight', {
    load: function load(element) {
        if (mpPartnerScript != '') {
            postscribe('#mpPartnerRightContent', mpPartnerScript);
        }
    }
});
observerLozadAds.observe();
var observerLozadAdsDetail = lozad('#mpPartnerOfferDetail', {
    load: function load(element) {
        if (mpPartnerScriptDetail != '') {
            postscribe('#mpPartnerOfferDetail', mpPartnerScriptDetail);
        }
    }
});
observerLozadAdsDetail.observe();
